<template>
    <nav class="navbar navbar-expand-lg bg-secondary-subtle">
        <div class="container-fluid">
            <span class="navbar-brand">Contributor admin</span>
            <button class="navbar-toggler" type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#admin_navbar" aria-controls="admin_navbar" aria-expanded="false"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="admin_navbar">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <router-link :to="{name: 'dashboard'}"
                                     :class="{'active': route.name === 'dashboard'}"
                                     class="nav-link">
                            Dashboard
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin"
                        class="nav-item">
                        <router-link :to="{name: 'usersAdminList'}"
                                     :class="{'active': route.meta.submodule === 'users'}"
                                     class="nav-link">
                            Users
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin"
                        class="nav-item">
                        <router-link :to="{name: 'jurisdictions'}"
                                     :class="{'active': route.name === 'jurisdictions'}"
                                     class="nav-link">
                            Jurisdictions
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link
                            :to="{name: state.isEconomist ? 'economistsConsultancyListView' : 'lawFirmsListView'}"
                            :class="{'active': route.meta.submodule === 'experts'}"
                            class="nav-link">
                            Experts
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin || state.isContributor"
                        class="nav-item">
                        <router-link :to="{name: 'competitionAuthorities'}"
                                     :class="{'active': route.meta.submodule === 'authorities'}"
                                     class="nav-link">
                            Authorities
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin"
                        class="nav-item">
                        <router-link :to="{name: 'newsList'}"
                                     :class="{'active': route.meta.submodule === 'news'}"
                                     class="nav-link">
                            News
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'jobsList'}"
                                     :class="{'active': route.meta.submodule === 'jobs'}"
                                     class="nav-link">
                            Jobs
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="{name: 'eventsList'}"
                                     :class="{'active': route.meta.submodule === 'events'}"
                                     class="nav-link">
                            Events
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'articlesList'}"
                                     :class="{'active': route.meta.submodule === 'articles'}"
                                     class="nav-link">
                            Articles
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin || state.isContributor"
                        class="nav-item">
                        <router-link :to="{name: 'decisionsListView'}"
                                     :class="{'active': route.meta.submodule === 'decisions'}"
                                     class="nav-link">
                            Decisions
                        </router-link>
                    </li>

                    <li v-if="state.isAdmin || state.isContributor" class="nav-item">
                        <router-link :to="{name:  (state.isAdmin ? 'mergerHeadings' : 'mergerGuide')}"
                                     :class="{'active': route.meta.submodule === 'guidesmerger'}"
                                     class="nav-link">
                            Merger Control
                        </router-link>
                    </li>
                    <li v-if="state.isAdmin || state.isContributor" class="nav-item">
                        <router-link :to="{name: (state.isAdmin ? 'foreignHeadings' : 'foreignGuide')}"
                                     :class="{'active': route.meta.submodule === 'guidesforeign'}"
                                     class="nav-link">
                            Foreign Investments
                        </router-link>
                    </li>

                    <li v-if="state.isAdmin || state.isContributor"
                        class="nav-item">
                        <router-link :to="{name: state.isAdmin ? 'mailingListAdmin' : 'newsletterAdmin'}"
                                     :class="{'active': route.meta.submodule === 'newsletter'}"
                                     class="nav-link">
                            Newsletter
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'analytics'}"
                                     :class="{'active': route.name === 'analytics'}"
                                     class="nav-link">
                            Analytics
                        </router-link>
                    </li>
                </ul>

            </div>
        </div>
    </nav>

</template>

<script setup lang="ts">
import {computed, reactive} from "vue";
import {useRoute} from "vue-router";

import {useMainStore} from "@/stores/mainStore";


interface State {
    isAdmin: boolean
    isContributor: boolean
    isEconomist: boolean
}


const route = useRoute();
const mainStore = useMainStore();


const state: State = reactive({
    isAdmin: computed(() => mainStore.isAdmin),
    isContributor: computed(() => mainStore.isContributor),
    isEconomist: computed(() => mainStore.isEconomist),
})


</script>


<style scoped lang="scss">

</style>
